import React from "react";
import InnerBody from "../components/InnerBody";
import HeaderPanel from "../components/HeaderPanel";
import TitleBar from "../components/TitleBar";
import MediaViewer from "../components/MediaViewer";
import Header from "../components/Header";
const axios = require("axios");

class PageClientView extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isLoading: true };
  }

  componentWillMount() {
    this.fetchData();
  }

  componentWillReceiveProps() {
    this.fetchData();
  }

  fetchData() {
    this.setState({ isLoading: true });
    axios.get("https://jsonplaceholder.typicode.com/todos/1").then(response => {
      console.log(response);
      this.setState({ isLoading: false });
    });
  }

  render() {
    return (
      <div>
        <Header
          title="Freigabe"
          showProjectsDropdown={false}
          showProfile={false}
        />
        <InnerBody isLoading={this.state.isLoading} noSidebar>
          <HeaderPanel />
          <TitleBar title="Ansicht" />
          <MediaViewer editable={true} />
        </InnerBody>
      </div>
    );
  }
}

export default PageClientView;



// WEBPACK FOOTER //
// ./src/pages/PageClientView.js